import React, { useEffect } from 'react';
import { LearnerProfileProps } from "./LearnerProfile.props";
import { Grid } from "@mui/material";
import Box from '@mui/material/Box';
import { MyProfile } from "../../components/MyProfile/MyProfile";
import ActivityTimeline from "../../components/ActivityTimeline/ActivityTimeline";
import Badges from '../../components/Badges/Badges';
import EmailContentType from '../../components/EmailContentType/EmailContentType';
import { ContentHistory } from "../../components/ContentHistory/ContentHistory";
import { useDispatch } from "react-redux";
import { getBadgeAchievementsEvents, getBadgeAchievementsEventsDataSelector } from "../../redux/getBadgeAchievementSlice";
import { useAppSelector } from "../../redux/hooks";
import { LoadingPage } from "../../components/LoadingPage";
import { HAS_VALUES } from "../../constants/constants";
import { getBadgesEvents, getBadgesEventsDataSelector, resetBadgesEvents } from "../../redux/getBadgeSlice";
import { getCurrentCellStore } from '../../utils/util';
import {getProfilesEvents } from "../../redux/getProfileSlice";
import {useLocation, useNavigate} from "react-router-dom";
import { workSpaceEventsDataSelector } from '../../redux/workSpaceSlice';

const LearnerProfile: React.FC<LearnerProfileProps> = () => {
  const dispatch = useDispatch<any>();
  const { badgeAchievementsData, isLoading } = useAppSelector(getBadgeAchievementsEventsDataSelector);
  const { badgesData, isLoading: loadingBadge } = useAppSelector(getBadgesEventsDataSelector);
  const [isAchievementPopupOpen, setIsAchievementPopupOpen] = React.useState(false);
  const { profileData, isLoading: isLoadingMyprofile  } = useAppSelector(
    (state) => state.profilesEvents
  );
  const navigate = useNavigate();
  const location = useLocation();
  const { workSpaceCurrentData } = useAppSelector(workSpaceEventsDataSelector);
  const { learner_id, email } = location.state || {};
  const cellId = location.state?.cell_id;
  const userCurrentCellStore = location.state?.isManagerView ? location.state : getCurrentCellStore();
  useEffect(() => {
    if (!workSpaceCurrentData) return;
    if (!location.state || workSpaceCurrentData.cell_id !== location.state.cell_id) {
      navigate('/courses');
      return;
    }
    const params = {
      learner_id,
      email,
      cell_id: cellId
    };
    dispatch(getBadgeAchievementsEvents(params));
    dispatch(getBadgesEvents(params));
    dispatch(getProfilesEvents({...params,type:'full'}));
    return () => {
      dispatch(resetBadgesEvents());
    };
  }, [workSpaceCurrentData])

  const shouldRedirect =
    !workSpaceCurrentData ||
    !location.state ||
    workSpaceCurrentData.cell_id !== location.state.cell_id;

  if (shouldRedirect) return null;

  return (
    <>
      <Box sx={{ flexGrow: 1, mt: '85px', mr: '20px', ml:'20px', mb:'20px'}}>
        <Grid container spacing={'20px'}>
          <Grid item >
            <Box width="400px" bgcolor="white">
              <MyProfile 
                profileData={profileData} 
                learnerName={`${location.state?.first_name ?? ''} ${location.state?.last_name ?? ''}`.trim()}
                isManagerView={location.state?.isManagerView}
                cellStore={userCurrentCellStore}
              />
            </Box>
          </Grid>
          <Grid item xs sm md lg xl style={{ overflow: 'hidden' }}>
            {badgeAchievementsData?.has_achievement === HAS_VALUES.TRUE ? <Box bgcolor="white" mb={'20px'} >
              <Badges 
                data={badgesData ?? {}} 
                onOpenAchievementChange={setIsAchievementPopupOpen}
              />
            </Box> : null}
            {userCurrentCellStore?.show_phishing_data && (
              <Box bgcolor="white" mb={'20px'}>
                <EmailContentType data={badgeAchievementsData?.email_content_type ?? {}} />
              </Box>
            )}
            <Box bgcolor="white" mb={'20px'}>
              <ActivityTimeline text = {`Timeline of your phishing reports and training activity`} data={badgeAchievementsData?.timeline_summary ?? {}} />
            </Box>
            <Box bgcolor="white" mb={'20px'}>
              <ContentHistory text = {`Your past phishing simulations and training activity`} data={badgeAchievementsData?.content_histories} />
            </Box>
          </Grid>
        </Grid>
      </Box>
      <LoadingPage open={!isAchievementPopupOpen && (isLoading || loadingBadge || isLoadingMyprofile)} />
    </>
  );
};

export default LearnerProfile;
